import React from 'react';
import {h, Component} from 'preact'
import _ from "lodash";

export default class FileItem extends Component {
    render() {
        const { file, deleteItem } = this.props;
        return (
            <div className={'file-list'}>
                <div className={'file-item'}>
                    <i className={'icon-file-image-solid'}/>
                    <span className={'file-name'}>{
                        _.truncate(file.name, {
                            length: 25
                        })
                    }</span>
                    <i onClick={deleteItem}
                       className={'delete-file icon-times-solid'}/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/FileItem.js